import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonSharedModule } from 'src/app/shared/common/common-shared.module';
import { KendoModule } from 'src/app/shared/kendo/kendo.module';
import { OnboardingSharedModule } from 'src/app/shared/onboarding/onboarding-shared.module';
import { ApStatementsComponent } from './ap-statements/ap-statements.component';
import { ArStatementsComponent } from './ar-statements/ar-statements.component';
import { BalanceSheetsComponent } from './balance-sheets/balance-sheets.component';
import { BankStatementsComponent } from './bank-statements/bank-statements.component';
import { FinancialProfileRoutingModule } from './financial-profile-routing.module';
import { InvoiceAmountComponent } from './invoice-amount/invoice-amount.component';
import { InvoiceTermComponent } from './invoice-term/invoice-term.component';
import { PlStatementsComponent } from './pl-statements/pl-statements.component';
import { SummaryComponent } from './summary/summary.component';

const components = [
  InvoiceAmountComponent,
  InvoiceTermComponent,
  BalanceSheetsComponent,
  BankStatementsComponent,
  PlStatementsComponent,
  ArStatementsComponent,
  ApStatementsComponent,
  SummaryComponent,
];

const modules = [
  CommonModule,
  FinancialProfileRoutingModule,
  CommonSharedModule,
  KendoModule,
  OnboardingSharedModule,
];

@NgModule({
  declarations: [...components],
  imports: [...modules],
  exports: [...components, ...modules],
})
export class FinancialProfileModule {}
